// @ts-ignore
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ImpressaoCompraSelecao, MODELOS_COMPRA } from '../compra-impressao/compra-impressao.model';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';

interface CompraLinha {
  nunota:       number;
  codemp:       number;
  dtmov:        string;
  fornecedor:   string;
  docparc:      string;
  empresa:      string;
  vlrnota:      number;
  vlrmoeda:     number;
  vlripi:       number;
  vlrst:        number;
  vlrcoreusd:   number;
  status:       string;
  comprador:    string;
  tipoOperacao: string;
  codTipOper:   number;
  observacao:   string;
  gplStatus:    string;
  prioridade:   string;
  tipoGpl:      string;
}

// @ts-ignore
@Component({
  selector: 'app-compra-lista',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './compra-lista.component.html',
  styleUrls: ['./compra-lista.component.css']
})
export class CompraListaComponent implements OnInit, OnDestroy {

  @Output() novoPedido   = new EventEmitter<void>();
  @Output() editarPedido = new EventEmitter<number>();
  @Output() imprimirPedido = new EventEmitter<ImpressaoCompraSelecao>();

  readonly relatoriosImpressao = MODELOS_COMPRA.filter(relatorio => relatorio.modelo !== 'PEDIDO_COMPRA');

  // ── Filtros ───────────────────────────────────────────────
  dtDe              = '';
  dtAte             = '';
  mostrarCancelados = false;
  termoBusca        = '';
  termoBuscaPn      = '';
  private _pnTimer: any = null;

  // ── Lista ─────────────────────────────────────────────────
  carregando = false;
  pedidos: CompraLinha[] = [];
  erro = '';

  // ── Paginação ─────────────────────────────────────────────
  paginaAtual    = 1;
  itensPorPagina = 11;
  readonly opcoesPorPagina = [11, 25, 50, 100];

  // ── Dropdown ações ────────────────────────────────────────
  dropdownAberto: number | null = null;

  private empresaSub?: Subscription;

  constructor(
    private readonly gateway: SankhyaGatewayService,
    readonly empresa: EmpresaStateService
  ) {}

  ngOnInit(): void {
    const hoje = new Date();
    this.dtAte = this.toInputDate(hoje);
    const trintaDiasAtras = new Date(hoje);
    trintaDiasAtras.setDate(hoje.getDate() - 30);
    this.dtDe = this.toInputDate(trintaDiasAtras);

    this.empresaSub = this.empresa.empresaMudou.subscribe(() => this.buscar());
    this.buscar();
  }

  ngOnDestroy(): void {
    this.empresaSub?.unsubscribe();
    clearTimeout(this._pnTimer);
  }

  buscar(): void {
    // Empresa virtual (ex.: 12): CODEMP real nas notas + filtro por GPL_EMPRESA_VIRTUAL.
    const empVirtual = this.empresa.selecionadaEhVirtual ? Number(this.empresa.selecionada) : 0;
    const codEmp = empVirtual > 0 ? Number(this.empresa.codEmpReal) : Number(this.empresa.selecionada);
    if (!codEmp || !this.dtDe || !this.dtAte) return;

    this.carregando = true;
    this.erro = '';
    this.paginaAtual = 1;

    const dtDe = this.toSankhyaDate(this.dtDe);
    const dtAte = this.toSankhyaDate(this.dtAte);

    this.gateway.listarCompras(codEmp, dtDe, dtAte, this.mostrarCancelados, this.termoBuscaPn, empVirtual).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        const lista = body?.lista ?? [];
        this.pedidos = lista.map((r: any): CompraLinha => ({
          nunota:       Number(r.nunota      ?? 0),
          codemp:       Number(r.codemp      ?? 0),
          dtmov:        r.dtmov              ?? '',
          fornecedor:   r.fornecedor         ?? '',
          docparc:      r.docparc            ?? '',
          empresa:      r.empresa            ?? '',
          vlrnota:      Number(r.vlrnota     ?? 0),
          vlrmoeda:     Number(r.vlrmoeda    ?? 1),
          vlripi:       Number(r.vlripi      ?? 0),
          vlrst:        Number(r.vlrst       ?? 0),
          vlrcoreusd:   Number(r.vlrcoreusd  ?? 0),
          status:       r.status             ?? '',
          comprador:    r.comprador          ?? '',
          tipoOperacao: r.tipoOperacao       ?? '',
          codTipOper:   Number(r.codTipOper  ?? 0),
          observacao:   r.observacao         ?? '',
          gplStatus:    r.gplStatus          ?? '',
          prioridade:   r.prioridade         ?? '',
          tipoGpl:      r.tipoGpl            ?? '',
        }));
        this.carregando = false;
      },
      error: (err: any) => {
        this.erro = err?.error?.erro ?? err?.message ?? 'Erro ao buscar compras.';
        this.carregando = false;
      }
    });
  }

  // ── Filtros reativos ──────────────────────────────────────

  // ── Ordenação por coluna (clique no cabeçalho) ──
  ordenarCampo: string | null = null;
  ordenarAsc = true;

  ordenar(campo: string): void {
    if (this.ordenarCampo === campo) {
      this.ordenarAsc = !this.ordenarAsc;
    } else {
      this.ordenarCampo = campo;
      this.ordenarAsc = true;
    }
    this.paginaAtual = 1;
  }

  private valorOrdenacao(p: CompraLinha, campo: string): number | string {
    switch (campo) {
      case 'nunota':  return Number(p.nunota) || 0;
      case 'codemp':  return Number(p.codemp) || 0;
      case 'status':  return (p.gplStatus || '').toLowerCase();
      case 'tipo':    return this.fmtTipo(p.tipoGpl).toLowerCase();
      case 'dtmov': {
        const m = String(p.dtmov || '').match(/(\d{2})\/(\d{2})\/(\d{4})(?:\D+(\d{2}):(\d{2}))?/);
        return m ? new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0)).getTime() : 0;
      }
      case 'vlr':     return this.vlrTotal(p) || 0;
      case 'vlrusd':  return this.vlrTotalUsd(p) || 0;
      default:        return String((p as any)[campo] ?? '').toLowerCase();
    }
  }

  get pedidosFiltrados(): CompraLinha[] {
    const lista = this.pedidosFiltradosSemOrdem;
    const campo = this.ordenarCampo;
    if (!campo) return lista;
    const dir = this.ordenarAsc ? 1 : -1;
    return [...lista].sort((a, b) => {
      const va = this.valorOrdenacao(a, campo);
      const vb = this.valorOrdenacao(b, campo);
      if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
      return String(va).localeCompare(String(vb), 'pt-BR', { numeric: true }) * dir;
    });
  }

  private get pedidosFiltradosSemOrdem(): CompraLinha[] {
    const termo = this.termoBusca.trim().toLowerCase();
    if (!termo) return this.pedidos;
    return this.pedidos.filter(p =>
      (p.fornecedor  || '').toLowerCase().includes(termo) ||
      (p.docparc     || '').toLowerCase().includes(termo) ||
      (p.comprador   || '').toLowerCase().includes(termo)
    );
  }

  get totalPaginas(): number {
    return Math.max(1, Math.ceil(this.pedidosFiltrados.length / this.itensPorPagina));
  }

  get pedidosPagina(): CompraLinha[] {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    return this.pedidosFiltrados.slice(inicio, inicio + this.itensPorPagina);
  }

  get paginas(): number[] {
    const total = this.totalPaginas;
    const atual = this.paginaAtual;
    const range: number[] = [];
    for (let i = Math.max(1, atual - 2); i <= Math.min(total, atual + 2); i++) {
      range.push(i);
    }
    return range;
  }

  irParaPagina(p: number): void {
    if (p < 1 || p > this.totalPaginas) return;
    this.paginaAtual = p;
  }

  onItensPorPaginaChange(): void { this.paginaAtual = 1; }
  onTermoBuscaChange(): void     { this.paginaAtual = 1; }
  onMostrarCanceladosChange(): void { this.buscar(); }

  onTermoBuscaPnChange(): void {
    clearTimeout(this._pnTimer);
    this._pnTimer = setTimeout(() => this.buscar(), 500);
  }

  // ── Cálculos de valor ─────────────────────────────────────

  vlrTotal(p: CompraLinha): number {
    return (p.vlrnota || 0) + (p.vlripi || 0) + (p.vlrst || 0);
  }

  vlrTotalUsd(p: CompraLinha): number {
    const cotacao = p.vlrmoeda || 1;
    return ((p.vlrnota || 0) + (p.vlripi || 0) + (p.vlrst || 0)) / cotacao;
  }

  fmtBrl(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
  }

  fmtUsd(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(v);
  }

  /** GPL_TIPO (TGFCAB) -- código gravado sem acento (IMPORTACAO), exibido
   *  com o rótulo correto (IMPORTAÇÃO). */
  fmtTipo(v: string | null | undefined): string {
    if (!v) return '—';
    if (v === 'IMPORTACAO') return 'IMPORTAÇÃO';
    return v;
  }

  /** Cor do badge de Tipo (Origem) -- IMPORTACAO em lilás, NACIONAL em azul-petróleo,
   *  igual ao padrão visual do sistema legado (Aerosys). */
  tipoClass(v: string | null | undefined): string {
    const t = (v || '').toUpperCase().trim();
    if (t === 'IMPORTACAO' || t === 'IMPORTAÇÃO') return 'tipo-importacao';
    if (t === 'NACIONAL') return 'tipo-nacional';
    return 'tipo-outro';
  }

  /** Cor do badge de Status (GPL_STATUS) -- mesmo estilo visual (badge colorido)
   *  do sistema legado (Aerosys), mas usando os valores do Sankhya. COMPRADO e
   *  PARCIAL são os dois valores que faltavam no domínio GPL_STATUS (o usuário
   *  vai cadastrar no DataDictionary) -- já mapeados aqui com as mesmas cores
   *  do legado (verde/laranja) assim que existirem. */
  statusClass(status: string | null | undefined): string {
    const s = (status || '').toUpperCase().trim();
    switch (s) {
      case 'COMPRADO':
      case 'ENTREGUE':
      case 'FATURADO':
      case 'FINALIZADO':
      case 'PRONTO':
        return 'status-liberado';   // verde
      case 'AUTORIZADO':
      case 'ESTOQUE':
        return 'status-atendido';   // azul
      case 'ABERTO':
      case 'PENDENTE':
      case 'PARCIAL':
        return 'status-pendente';   // amarelo
      case 'CANCELADO':
      case 'ESTORNAR':
        return 'status-cancelado';  // vermelho
      case 'CONFERENCIA':
      case 'LOGISTICA':
      case 'CONTAGEM':
      case 'SEPARACAO':
      case 'SEPARACAO TOTAL':
        return 'status-processo';   // roxo
      case 'GARANTIA':
        return 'status-alerta';     // laranja
      case 'BAIXADO':
        return 'status-outro';      // cinza
      default:
        return 'status-outro';
    }
  }

  /** Código da empresa no mesmo formato do legado (0000012). */
  fmtCodEmp(codemp: number | null | undefined): string {
    if (codemp == null) return '—';
    return String(codemp).padStart(7, '0');
  }

  // ── Dropdown ─────────────────────────────────────────────

  toggleDropdown(event: Event, p: CompraLinha): void {
    event.stopPropagation();
    this.dropdownAberto = this.dropdownAberto === p.nunota ? null : p.nunota;
  }

  /** Duplo clique na linha abre o pedido em edição -- mesmo padrão do
   *  Pedido de Venda (onDblClickLinha em pedido-venda-lista.component.ts).
   *  Não checa status aqui: a própria tela de edição decide se abre travada
   *  (só leitura) ou editável, conforme o GPL_STATUS do pedido. */
  onDblClickLinha(p: CompraLinha): void {
    this.editarPedido.emit(p.nunota);
  }

  fecharDropdown(): void { this.dropdownAberto = null; }

  // ── Utilitários de data ──────────────────────────────────

  private toInputDate(d: Date): string {
    return d.toISOString().substring(0, 10);
  }

  private toSankhyaDate(iso: string): string {
    const [y, m, dia] = iso.split('-');
    return `${dia}/${m}/${y}`;
  }
}
